(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sshop-product-information"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll(".sshop-pi").forEach(function (root) {
    if (root.dataset.sshopPiInit === "1") return;
    root.dataset.sshopPiInit = "1";

    var main = root.querySelector("[data-sshop-pi-main]");
    root.querySelectorAll("[data-sshop-pi-thumb]").forEach(function (t, i) {
      if (i === 0) t.classList.add("is-on");
      t.addEventListener("click", function () {
        if (main) main.src = t.getAttribute("data-sshop-pi-thumb");
        root.querySelectorAll("[data-sshop-pi-thumb]").forEach(function (o) { o.classList.remove("is-on"); });
        t.classList.add("is-on");
      });
    });

    var idInput = root.querySelector("[data-sshop-pi-id]");
    // Blocks that follow the variant (stock, sticky bar, buy button) listen to
    // the form's own id field, so a change there has to be announced.
    var announce = function () {
      if (idInput) idInput.dispatchEvent(new Event("change", { bubbles: true }));
    };

    root.querySelectorAll("[data-sshop-pi-v]").forEach(function (b) {
      b.addEventListener("click", function () {
        root.querySelectorAll("[data-sshop-pi-v]").forEach(function (o) { o.classList.remove("is-on"); });
        b.classList.add("is-on");
        if (idInput) idInput.value = b.getAttribute("data-sshop-pi-v");
        var name = root.querySelector("[data-sshop-pi-vname]");
        if (name) name.textContent = b.getAttribute("data-sshop-pi-vtitle");
        var price = root.querySelector("[data-sshop-pi-price]");
        if (price) price.textContent = b.getAttribute("data-sshop-pi-vprice");
        announce();
      });
    });

    // One choice per option: the variant is whichever matches all of them.
    var opts = root.querySelector("[data-sshop-pi-opts]");
    if (!opts) return;
    var variants = [];
    try { variants = JSON.parse(opts.querySelector("[data-sshop-pi-variants]").textContent); } catch (e) { return; }
    var sets = Array.prototype.slice.call(opts.querySelectorAll("[data-sshop-pi-opt]"));
    var add = root.querySelector(".sshop-pi__add");
    var now = root.querySelector("[data-sshop-pi-now]");
    var was = root.querySelector("[data-sshop-pi-was]");
    var off = root.querySelector("[data-sshop-pi-off]");

    var chosen = function () {
      return sets.map(function (set) {
        var on = set.querySelector(".is-on");
        return on ? on.getAttribute("data-value") : null;
      });
    };
    var matches = function (variant, pick) {
      return variant.o.every(function (value, i) { return value === pick[i]; });
    };
    var mark = function (pick) {
      sets.forEach(function (set, i) {
        set.querySelectorAll("[data-value]").forEach(function (b) {
          var trial = pick.slice();
          trial[i] = b.getAttribute("data-value");
          var open = variants.some(function (variant) { return variant.a && matches(variant, trial); });
          b.classList.toggle("is-gone", !open);
        });
      });
    };
    var sync = function () {
      var pick = chosen();
      var hit = variants.filter(function (variant) { return matches(variant, pick); })[0];
      mark(pick);
      if (!hit) return;
      if (idInput) idInput.value = hit.id;
      if (now) now.textContent = hit.p;
      if (was) { was.textContent = hit.c; was.hidden = !hit.c; }
      if (off) {
        off.textContent = off.getAttribute("data-words") === "save"
          ? off.getAttribute("data-save") + " " + hit.d + "%"
          : "-" + hit.d + "%";
        off.hidden = !hit.d;
      }
      if (add) {
        add.disabled = !hit.a;
        add.textContent = hit.a ? add.getAttribute("data-label") : add.getAttribute("data-sold");
        if (hit.a && add.getAttribute("data-show-price") === "true") {
          var price = document.createElement("span");
          price.setAttribute("data-sshop-pi-price", "");
          price.textContent = hit.p;
          add.appendChild(document.createTextNode(" • "));
          add.appendChild(price);
        }
      }
      announce();
    };

    opts.addEventListener("click", function (e) {
      var b = e.target.closest("[data-value]");
      if (!b || !opts.contains(b)) return;
      var set = b.closest("[data-sshop-pi-opt]");
      set.querySelectorAll("[data-value]").forEach(function (o) {
        o.classList.remove("is-on");
        o.setAttribute("aria-pressed", "false");
      });
      b.classList.add("is-on");
      b.setAttribute("aria-pressed", "true");
      var label = set.querySelector("[data-sshop-pi-optname]");
      if (label) label.textContent = b.getAttribute("data-value");
      sync();
    });
    mark(chosen());
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sshop-product-studio"] && !Shopify.designMode) return;
  try {
    
(function () {
  // One run per section, replaced whenever the editor renders it again.
  var runs = window.__sshopPsRuns || (window.__sshopPsRuns = {});
  var list = function (scope, sel) { return Array.prototype.slice.call(scope.querySelectorAll(sel)); };

  function start(root) {
    var sid = root.getAttribute("data-ps");
    if (runs[sid]) runs[sid].abort();
    var life = new AbortController();
    runs[sid] = life;
    var on = function (el, type, fn, passive) {
      if (el) el.addEventListener(type, fn, { signal: life.signal, passive: !!passive });
    };

    // ── The gallery ─────────────────────────────────────────────────────────
    var track = root.querySelector("[data-ps-track]");
    var frames = track ? list(track, "[data-ps-slide]") : [];
    var minis = list(root, "[data-ps-go]");
    var dots = list(root, "[data-ps-dot]");
    var backArrow = root.querySelector(".sshop-ps__arrow.is-prev");
    var onArrow = root.querySelector(".sshop-ps__arrow.is-next");
    var count = root.querySelector("[data-ps-count]");
    var strip = root.querySelector("[data-ps-thumbs]");
    var more = root.querySelector("[data-ps-thumbs-more]");
    var current = -1;

    function mark(i) {
      current = i;
      minis.forEach(function (t, k) {
        t.classList.toggle("is-on", k === i);
        t.setAttribute("aria-current", k === i ? "true" : "false");
      });
      dots.forEach(function (d, k) { d.classList.toggle("is-on", k === i); });
      if (backArrow) backArrow.disabled = i <= 0;
      if (onArrow) onArrow.disabled = i >= frames.length - 1;
      if (count) count.textContent = i + 1 + " / " + frames.length;
      var t = minis[i];
      if (t && strip) {
        // Only the strip scrolls, never the page.
        var box = strip.getBoundingClientRect();
        var r = t.getBoundingClientRect();
        if (r.left < box.left || r.right > box.right) strip.scrollBy({ left: r.left - box.left - (box.width - r.width) / 2, behavior: "smooth" });
        if (r.top < box.top || r.bottom > box.bottom) strip.scrollBy({ top: r.top - box.top - (box.height - r.height) / 2, behavior: "smooth" });
      }
    }
    function goTo(i, instant) {
      if (!track || !frames.length) return;
      i = Math.max(0, Math.min(frames.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: instant ? "auto" : "smooth" });
      mark(i);
    }

    var ticking = false;
    on(track, "scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== current) mark(i);
      });
    }, true);
    on(track, "keydown", function (e) {
      if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
        e.preventDefault();
        goTo(current + (e.key === "ArrowRight" ? 1 : -1));
      }
    });
    on(backArrow, "click", function () { goTo(current - 1); });
    on(onArrow, "click", function () { goTo(current + 1); });
    minis.forEach(function (t) {
      on(t, "click", function () {
        goTo(+t.getAttribute("data-ps-go"));
        // Laid out as a grid, a photo can sit well below the one on show.
        if (strip && track && getComputedStyle(strip).display === "grid") {
          var top = track.getBoundingClientRect().top;
          if (top < 0) window.scrollBy({ top: top - 24, behavior: "smooth" });
        }
      });
    });
    on(window, "resize", function () { if (current > -1) goTo(current, true); }, true);

    if (strip && more) {
      var room = function () {
        more.hidden = strip.scrollWidth <= strip.clientWidth + 2 || strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 2;
      };
      on(more, "click", function () { strip.scrollBy({ left: strip.clientWidth * 0.8, behavior: "smooth" }); });
      on(strip, "scroll", room, true);
      on(window, "resize", room, true);
      room();
    }
    goTo(+root.getAttribute("data-start") || 0, true);

    // ── The variant ─────────────────────────────────────────────────────────
    var form = root.querySelector("[data-ps-form]") || root.querySelector("form");
    var idField = root.querySelector("[data-ps-id]");
    var box = root.querySelector("[data-ps-options]");
    var variants = [];
    try { variants = box ? JSON.parse(box.querySelector("[data-ps-variants]").textContent) : []; } catch (e) { variants = []; }
    var sets = box ? list(box, "[data-ps-option]") : [];

    var picked = function (set) {
      var menu = set.querySelector("[data-ps-select]");
      if (menu) return menu.value;
      var chip = set.querySelector("[data-value].is-on");
      return chip ? chip.getAttribute("data-value") : null;
    };
    var same = function (variant, pick) {
      return variant.o.every(function (value, i) { return value === pick[i]; });
    };
    // A value stays open when some variant with it, and the other choices as
    // they are, can still be bought.
    function shade(pick) {
      sets.forEach(function (set, i) {
        list(set, "[data-value]").forEach(function (chip) {
          var trial = pick.slice();
          trial[i] = chip.getAttribute("data-value");
          chip.classList.toggle("is-gone", !variants.some(function (v) { return v.a && same(v, trial); }));
        });
      });
    }
    function paintBuy(buy, available, price) {
      var btn = buy.querySelector(".sshop-ps__buy-btn");
      var words = buy.querySelector("[data-ps-buy-words]");
      if (!btn || !words) return;
      btn.disabled = !available;
      var text = available ? buy.getAttribute("data-label") : buy.getAttribute("data-sold");
      if (available && price && buy.getAttribute("data-price") === "true") text += " " + buy.getAttribute("data-joiner") + " " + price;
      words.textContent = text;
    }
    function applyVariant(hit) {
      if (idField && idField.value !== String(hit.id)) {
        idField.value = hit.id;
        // Blocks that follow the variant (stock, sticky bar) listen to the form's id field.
        idField.dispatchEvent(new Event("change", { bubbles: true }));
      }
      list(root, "[data-ps-pricing]").forEach(function (pricing) {
        var now = pricing.querySelector("[data-ps-now]");
        var was = pricing.querySelector("[data-ps-was]");
        var cut = pricing.querySelector("[data-ps-cut]");
        var bubble = pricing.querySelector("[data-ps-bubble]");
        if (now) now.textContent = hit.p;
        if (was) { was.textContent = hit.c; was.hidden = !hit.c; }
        if (cut) {
          var words = pricing.getAttribute("data-words");
          var save = pricing.getAttribute("data-save");
          cut.textContent = words === "save_percent" ? save + " " + hit.d + "%" : words === "save_amount" ? save + " " + hit.s : "-" + hit.d + "%";
          cut.hidden = !hit.d;
        }
        if (bubble) {
          bubble.textContent = (bubble.getAttribute("data-pattern") || "").split("{saved}").join(hit.s || "").split("{off}").join(hit.d + "%");
          bubble.hidden = bubble.getAttribute("data-when") === "sale" && !hit.d;
        }
      });
      paintOffers(hit.id);
      list(root, "[data-ps-purchase]").forEach(function (buy) {
        var tier = offerPrice(hit.id);
        paintBuy(buy, hit.a, tier ? tier.p : hit.p);
      });
      if (hit.m !== null && hit.m !== undefined) {
        for (var k = 0; k < frames.length; k++) {
          if (frames[k].getAttribute("data-media") === String(hit.m)) { goTo(k); break; }
        }
      }
      if (!(window.Shopify && window.Shopify.designMode) && window.history && window.history.replaceState) {
        try {
          var address = new URL(window.location.href);
          address.searchParams.set("variant", hit.id);
          window.history.replaceState(window.history.state, "", address.toString());
        } catch (e) { /* the address bar is only a courtesy */ }
      }
    }
    function sync() {
      var pick = sets.map(picked);
      shade(pick);
      var hit = variants.filter(function (v) { return same(v, pick); })[0];
      if (hit) return applyVariant(hit);
      list(root, "[data-ps-purchase]").forEach(function (buy) { paintBuy(buy, false, ""); });
    }
    if (box) {
      on(box, "click", function (e) {
        var chip = e.target.closest && e.target.closest("[data-value]");
        if (!chip || !box.contains(chip)) return;
        var set = chip.closest("[data-ps-option]");
        list(set, "[data-value]").forEach(function (o) {
          o.classList.toggle("is-on", o === chip);
          o.setAttribute("aria-pressed", o === chip ? "true" : "false");
        });
        var name = set.querySelector("[data-ps-picked]");
        if (name) name.textContent = chip.getAttribute("data-value");
        sync();
      });
      on(box, "change", function (e) {
        var menu = e.target.closest && e.target.closest("[data-ps-select]");
        if (!menu) return;
        var name = menu.closest("[data-ps-option]").querySelector("[data-ps-picked]");
        if (name) name.textContent = menu.value;
        sync();
      });
      shade(sets.map(picked));
    }

    // ── Countdowns ──────────────────────────────────────────────────────────
    list(root, "[data-ps-timer]").forEach(function (clock) {
      var face = clock.querySelector("[data-ps-time]");
      if (!face) return;
      var byMinutes = clock.getAttribute("data-mode") === "minutes";
      var cycle = byMinutes ? (+clock.getAttribute("data-minutes") || 30) * 60000 : 86400000;
      var end = +clock.getAttribute("data-end") * 1000;
      if (byMinutes) {
        // A set time from the shopper's first view, kept for the visit.
        var key = "sshop-ps-timer-" + sid;
        var kept = 0;
        try { kept = +sessionStorage.getItem(key) || 0; } catch (e) { kept = 0; }
        end = kept > Date.now() ? kept : Date.now() + cycle;
        try { sessionStorage.setItem(key, String(end)); } catch (e) { /* storage refused: this view counts alone */ }
      }
      var two = function (n) { return (n < 10 ? "0" : "") + n; };
      var tick = function () {
        // Run out, it starts over: the next midnight, or another round.
        while (end <= Date.now()) end += cycle;
        var left = Math.floor((end - Date.now()) / 1000);
        face.textContent = two(Math.floor(left / 3600)) + ":" + two(Math.floor(left / 60) % 60) + ":" + two(left % 60);
      };
      tick();
      var beat = setInterval(tick, 1000);
      life.signal.addEventListener("abort", function () { clearInterval(beat); });
    });

    // ── Quantity offers ─────────────────────────────────────────────────────
    var offers = root.querySelector("[data-ps-offers]");
    var offerPrices = {};
    try { offerPrices = offers ? JSON.parse(offers.querySelector("[data-ps-offer-prices]").textContent) : {}; } catch (e) { offerPrices = {}; }
    function offerIndex() {
      var picked = offers && offers.querySelector(".sshop-ps__offer-pick:checked");
      return picked ? +picked.value - 1 : 0;
    }
    // The chosen offer's prices for a variant, or null without offers.
    function offerPrice(variantId) {
      var tiers = offerPrices[String(variantId)];
      return tiers && tiers[offerIndex()] ? tiers[offerIndex()] : null;
    }
    function paintOffers(variantId) {
      if (!offers) return;
      var tiers = offerPrices[String(variantId)] || [];
      list(offers, ".sshop-ps__offer").forEach(function (card) {
        var pick = card.querySelector(".sshop-ps__offer-pick");
        var tier = tiers[+pick.value - 1];
        card.classList.toggle("is-on", pick.checked);
        if (!tier) return;
        var now = card.querySelector("[data-ps-offer-now]");
        var was = card.querySelector("[data-ps-offer-was]");
        if (now) now.textContent = tier.p;
        if (was) { was.textContent = tier.c; was.hidden = !tier.c; }
      });
      var qty = offers.querySelector("[data-ps-offer-qty]");
      var chosen = offers.querySelector(".sshop-ps__offer-pick:checked");
      if (qty && chosen) qty.value = chosen.getAttribute("data-qty");
    }
    on(offers, "change", function (e) {
      if (!e.target.classList || !e.target.classList.contains("sshop-ps__offer-pick")) return;
      var id = idField && idField.value;
      paintOffers(id);
      var tier = offerPrice(id);
      list(root, "[data-ps-purchase]").forEach(function (buy) {
        var btn = buy.querySelector(".sshop-ps__buy-btn");
        paintBuy(buy, btn ? !btn.disabled : true, tier ? tier.p : "");
      });
    });

    list(root, "[data-ps-qty]").forEach(function (step) {
      on(step, "click", function () {
        var input = step.parentNode.querySelector("[name='quantity']");
        if (!input) return;
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + +step.getAttribute("data-ps-qty"));
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });

    // ── The cart ────────────────────────────────────────────────────────────
    on(form, "submit", function (e) {
      var btn = e.submitter && e.submitter.closest ? e.submitter.closest(".sshop-ps__buy-btn") : root.querySelector(".sshop-ps__buy-btn");
      var buy = btn && btn.closest("[data-ps-purchase]");
      if (!buy) return;
      e.preventDefault();
      if (!btn.disabled && !buy.hasAttribute("data-busy")) add(buy, btn);
    });

    function add(buy, btn) {
      var id = idField && idField.value;
      if (!id) return;
      var qty = form.querySelector("[name='quantity']");
      var line = { merchandiseId: String(id), quantity: Math.max(1, parseInt(qty && qty.value, 10) || 1) };
      var plan = form.querySelector("[name='selling_plan']");
      if (plan && plan.value) line.sellingPlanId = String(plan.value);
      var attrs = [];
      Array.prototype.forEach.call(form.elements, function (f) {
        var named = /^properties\[(.+)\]$/.exec(f.name || "");
        if (!named || f.disabled || f.type === "file" || f.value === "") return;
        if ((f.type === "checkbox" || f.type === "radio") && !f.checked) return;
        attrs.push({ key: named[1], value: String(f.value) });
      });
      if (attrs.length) line.attributes = attrs;
      var lines = [line].concat(extraLines());

      var after = buy.getAttribute("data-after") || "drawer";
      // A merchant trying the button in the editor stays in the editor.
      var editor = !!(window.Shopify && window.Shopify.designMode);
      if (editor) after = "stay";
      var actions = window.Shopify && window.Shopify.actions;
      var viaActions = !!(actions && typeof actions.updateCart === "function") && (after === "stay" || (after === "drawer" && inPlace(actions)));

      busy(buy, btn, true);
      tell(buy, "");
      // Read by the add-on blocks' network hooks, so their ticks are not added twice.
      window.__pbBuyAdding = true;
      Promise.resolve()
        .then(function () {
          return viaActions ? actions.updateCart({ lines: lines }, { event: { context: "product" } }) : postLines(lines);
        })
        .then(function (result) {
          window.__pbBuyAdding = false;
          // A refusal resolves rather than rejects: sold out, over the limit.
          var refused = result && result.userErrors;
          if (refused && refused.length) throw new Error(refused[0].message || "");
          dropExtras();
          var adjusted = result && result.warnings;
          if (adjusted && adjusted.length) tell(buy, adjusted[0].message || "");
          if (after === "cart" || (after === "drawer" && !viaActions)) return leave(path("cart"));
          if (after === "checkout") return leave(path("checkout"));
          if (after === "drawer") {
            return Promise.resolve(actions.openCart()).then(function () { busy(buy, btn, false); }, function () { leave(path("cart")); });
          }
          // Staying with no action to refresh the theme's cart: a stale cart is worse than a reload.
          if (!viaActions && !editor) return window.location.reload();
          busy(buy, btn, false);
          flash(buy);
        })
        .catch(function (err) {
          window.__pbBuyAdding = false;
          busy(buy, btn, false);
          tell(buy, (err && err.message) || "Try again");
        });
    }
  }

  // Whether updateCart refreshes this theme's cart in place: a theme that set
  // the action up, a Horizon-shaped cart or a Dawn-shaped one.
  function inPlace(actions) {
    var cartUpdate = actions.updateCart;
    if (typeof cartUpdate.isDefault === "function" && !cartUpdate.isDefault()) return true;
    var icon = document.querySelector("cart-icon");
    var items = document.querySelector("cart-items-component");
    if (icon && items && typeof icon.renderCartBubble === "function" && typeof items.updateQuantity === "function") return true;
    return list(document, "cart-drawer, cart-items, cart-notification, cart-drawer-items").some(function (el) {
      return typeof el.getSectionsToRender === "function";
    });
  }
  function postLines(lines) {
    var items = lines.map(function (l) {
      var item = { id: l.merchandiseId, quantity: l.quantity };
      if (l.sellingPlanId) item.selling_plan = l.sellingPlanId;
      if (l.attributes) {
        item.properties = {};
        l.attributes.forEach(function (a) { item.properties[a.key] = a.value; });
      }
      return item;
    });
    return fetch(path("cart/add.js"), {
      method: "POST",
      // The add-on blocks' fetch hook leaves a request with this header alone.
      headers: { "Content-Type": "application/json", Accept: "application/json", "x-pb-addons": "1" },
      body: JSON.stringify({ items: items }),
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || "");
        return {};
      });
    });
  }
  // What Section Shop's add-on blocks have ticked goes in with the product.
  function extraLines() {
    var out = [];
    (window.__pbExtraLines || []).forEach(function (source) {
      try {
        (source.lines() || []).forEach(function (l) {
          if (l && l.id) out.push({ merchandiseId: String(l.id), quantity: l.quantity > 0 ? l.quantity : 1 });
        });
      } catch (e) { /* one broken source must not stop the product */ }
    });
    return out;
  }
  function dropExtras() {
    (window.__pbExtraLines || []).forEach(function (source) {
      try { source.clear(); } catch (e) { /* the cart is right either way */ }
    });
  }
  function path(to) {
    return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/") + to;
  }
  function leave(address) { window.location.href = address; }
  function busy(buy, btn, yes) {
    if (yes) { buy.setAttribute("data-busy", ""); btn.setAttribute("aria-busy", "true"); }
    else { buy.removeAttribute("data-busy"); btn.removeAttribute("aria-busy"); }
  }
  function tell(buy, words) {
    var msg = buy.querySelector("[data-ps-msg]");
    if (msg && msg.textContent !== words) msg.textContent = words;
  }
  function flash(buy) {
    var words = buy.querySelector("[data-ps-buy-words]");
    var added = buy.getAttribute("data-added");
    if (!words || !added) return;
    var before = buy.__psBefore || words.textContent;
    buy.__psBefore = before;
    words.textContent = added;
    clearTimeout(buy.__psFlash);
    buy.__psFlash = setTimeout(function () {
      words.textContent = before;
      buy.__psBefore = null;
    }, 2000);
  }

  function boot(scope) { list(scope || document, "[data-ps]").forEach(start); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { boot(); });
  else boot();
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
  document.addEventListener("shopify:section:unload", function (e) {
    list(e.target, "[data-ps]").forEach(function (root) {
      var run = runs[root.getAttribute("data-ps")];
      if (run) run.abort();
    });
  });
  // Selecting a folding row in the editor opens it, so its words can be read.
  document.addEventListener("shopify:block:select", function (e) {
    var fold = e.target && e.target.closest && e.target.closest(".sshop-ps__fold");
    if (fold) fold.open = true;
  });
})();

  } catch(e) { console.error(e); }
})();
})();
